import './App.css';
import Footer from './Components/Landing Page/Footer';
import LandingPage from './Screens/LandingPage';
import {Routes, Route, useLocation} from "react-router-dom";
import PrivacyPolicyPage from './pages/PrivacyPolicyPage/PrivacyPolicyPage';
import {BlogPage1} from './pages/BlogPage/BlogPage1';
import React, {useEffect, useLayoutEffect} from 'react';
import CookiePolicyPage from "./pages/CookiePolicyPage/CookiePolicyPage";
import TermOfUsePage from "./pages/TermOfUsePage/TermOfUsePage";
import CandidateTermsOfUse from "./pages/CandidateTermsOfUse/CandidateTermsOfUse";
import RecruitmentUseCase from "./pages/UseCases/RecruitmentUseCase";
import StartupUseCase from "./pages/UseCases/StartupUseCase";
import ScaleupUseCase from "./pages/UseCases/ScaleupUseCase";
import LargeEnterpriseUseCase from "./pages/UseCases/LargeEnterpriseUseCase";
import SoftwareHouseUseCase from "./pages/UseCases/SoftwareHouseUseCase";
import EventOffer from "./pages/EventOffer/EventOffer";

function App() {

    function ScrollToTop() {
        const {pathname} = useLocation();

        useLayoutEffect(() => {
            window.scrollTo(0, 0);
        }, [pathname]);

        return null;
    }

    useEffect(() => {
        const hash = window.location.hash;
        const targetId = hash.replace('#', '');

        if (targetId) {
            const targetDiv = document.getElementById(targetId);

            if (targetDiv) {
                const rect = targetDiv.getBoundingClientRect();
                const x = rect.left;
                const y = rect.top;
                window.scrollTo(x, y);
            }
        }
    }, []);

    return (
        <>
            {/* <Navbar /> */}
            {/*<ScrollToTop/>*/}

            <Routes>
                <Route path="/" element={<LandingPage/>}/>
                <Route path="/privacy-policy" element={<PrivacyPolicyPage/>}/>
                <Route path="/use-case/recruitment" element={<RecruitmentUseCase/>}/>
                <Route path="/use-case/startup" element={<StartupUseCase/>}/>
                <Route path="/use-case/scaleup" element={<ScaleupUseCase/>}/>
                <Route path="/use-case/software-house" element={<SoftwareHouseUseCase/>}/>
                <Route path="/use-case/large-enterprise" element={<LargeEnterpriseUseCase/>}/>
                <Route path="/cookie-policy" element={<CookiePolicyPage/>}/>
                <Route path="/terms-of-use" element={<TermOfUsePage/>}/>
                <Route path="/candidate-terms-of-use" element={<CandidateTermsOfUse/>}/>
                <Route path="/eventoffer" element={<EventOffer/>}/>
            </Routes>

            <Footer/>
        </>
    );
}

export default App;
